import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

const detailText = (d) =>
  Object.entries(d || {})
    .filter(([, v]) => v !== null && v !== undefined && v !== "")
    .map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(", ") : v === true ? "sí" : v === false ? "no" : v}`)
    .join(" · ");

export const AuditTimeline = ({ woId, refreshKey }) => {
  const [logs, setLogs] = useState([]);
  useEffect(() => {
    api.get(`/work-orders/${woId}/audit`).then((r) => setLogs(r.data));
  }, [woId, refreshKey]);
  return (
    <ol className="relative space-y-4 border-l border-border pl-5" data-testid="audit-timeline">
      {logs.map((l) => (
        <li key={l.id} className="relative">
          <span className="absolute -left-[25px] top-1.5 h-2.5 w-2.5 rounded-full border-2 border-primary bg-background" />
          <div className="text-sm font-medium capitalize-first">{l.action}</div>
          <div className="text-xs text-muted-foreground">{l.user_name} · {fmtDateTime(l.at)}</div>
          {detailText(l.details) && <div className="mt-0.5 break-words font-mono text-[11px] text-slate-500">{detailText(l.details)}</div>}
        </li>
      ))}
      {logs.length === 0 && <li className="text-sm text-muted-foreground">Sin registros</li>}
    </ol>
  );
};
